var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav"},[_c('div',{staticClass:"main"},[_c('a',{staticClass:"item",on:{"click":_vm.dashboard}},[_vm._v("Dashboard")])]),_c('div',{staticClass:"right"},[(_vm.user)?_c('amplify-sign-out'):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }